

import React, { useState, useEffect } from 'react';
import { Table, Modal, Button, Form } from 'react-bootstrap';
import { IconContext } from 'react-icons';
import { BsChevronDown, BsChevronRight, BsPencil } from 'react-icons/bs';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';
import CatVacaciones from '../../../Services/Catalogos/CatVacaciones';
import DTOEmpleadoVac from '../CatEmpleados/DTO/DTOEmpleadoVac';
import DTOVacaciones from '../CatVacaciones/DTO/DTOVacaciones';
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo';
import Calendar from 'react-calendar';
import CalendarioPresolicitudes from './CalendarioPresolicitudes';
import CalendarioSolicitudes from './CalendarioVacaciones';
import 'react-calendar/dist/Calendar.css';
import DTOPresolicitud from '../CatVacaciones/DTO/DTOPresolicitud';
import DTOInsertVacaciones from '../CatVacaciones/DTO/DTOInsertVacaciones';
import { useMemo } from 'react';
import './ControlVacaciones.css'


const ControlVacaciones: React.FC = () => {
  const [empleados, setEmpleados] = useState<DTOEmpleadoVac[]>([]);
  const [vacaciones, setVacaciones] = useState<{ [key: string]: DTOVacaciones[] }>({});
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
  const [cargando, setCargando] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedVacacion, setSelectedVacacion] = useState<DTOVacaciones | null>(null);
// const [showPresolicitudModal, setShowPresolicitudModal] = useState(false);
const [showModalSolicitud, setShowModalSolicitud] = useState(false);
const [showDiaPagoCalendar, setShowDiaPagoCalendar] = useState<boolean>(false);

// const [presolicitudData, setPresolicitudData] = useState<Partial<DTOPresolicitud>>({
//   estado: 'Pendiente',
//   tipoSolicitud: 'Días a pagar', // Valor por defecto si lo deseas
//   diasSalteados: [],
// });


const [solicitudData, setSolicitudData] = useState<DTOInsertVacaciones>({
    numEmpleado: '',
    tipoSolicitud: 'VacacionesPorDisfrutar',
    diasSolicitados: 0,
    diasPagar: 0,
    diasSalteados: [],
    fechaInicio: '',
    fechaFin: '',
    observaciones: '', 
    estado: 'Anticipada', 
    diaPago: null
  });

const [currentPage, setCurrentPage] = useState(1);
const empleadosPerPage = 10;
const indexOfLastEmpleado = currentPage * empleadosPerPage;
const indexOfFirstEmpleado = indexOfLastEmpleado - empleadosPerPage;
const currentEmpleados = empleados.slice(indexOfFirstEmpleado, indexOfLastEmpleado);
const totalPages = Math.ceil(empleados.length / empleadosPerPage);


const [recargarCalendario, setRecargarCalendario] = useState(false);






 
      const [show, setShowMsg] = useState(false)
      const [msg, setMsg] = useState('')
      const [header, setHeader] = useState('')
      const msgColor = 'primary'


  useEffect(() => {
    const idUsuario = localStorage.getItem('UserId')?.replace(/"/g, '');
    if (idUsuario) {
      cargarEmpleados(idUsuario);
    }
  }, [], );



  const [isFotoFirmaValida, setIsFotoFirmaValida] = useState<boolean>(false);

const validarFotoFirma = async (): Promise<void> => {
  const numEmpleado = localStorage.getItem('numEmpleado')?.replace(/"/g, '');
  
  if (!numEmpleado) {
    console.error('No se encontró el número de empleado en localStorage');
    return;
  }

  try {
    const fotoUrl = await CatEmpleados.GetFotoFirma(numEmpleado, 'foto');
    const firmaUrl = await CatEmpleados.GetFotoFirma(numEmpleado, 'firma');

    setIsFotoFirmaValida(!!(fotoUrl && firmaUrl));
  } catch (error) {
    console.error('Error al validar foto o firma:', error);
    setIsFotoFirmaValida(false);
  }
};

useEffect(() => {
  validarFotoFirma();
}, []);

  useEffect(() => {
    // Si ya tienes los empleados cargados, proceder a cargar las vacaciones
    if (empleados.length > 0) {
      empleados.forEach((empleado) => {
        cargarVacaciones(empleado.numEmpleado);
      });
    }
  }, [empleados]);


  useEffect(() => {
    const interval = setInterval(() => {
      empleados.forEach((empleado) => {
        cargarVacaciones(empleado.numEmpleado);
        

      });
    }, 10000); // Se actualizarán los datos cada 10 segundos
  
    return () => clearInterval(interval); // Limpia el intervalo cuando el componente se desmonta
  }, [empleados]);
  
  

  const formatearFechaISO = (fecha: string) => {
    if (!fecha) return '';
  
    // Validar que la fecha tenga el formato esperado
    const partesFecha = fecha.split('-'); // Separar por "-"
    if (partesFecha.length !== 3) return ''; // Validar que tenga 3 partes (AAAA-MM-DD)
  
    const [anio, mes, dia] = partesFecha; // Extraer partes
    return `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${anio}`; // Retornar en formato DD/MM/AAAA
  };
  
  // Función para formatear una fecha genérica (usada para `fechaSolicitud`)
  const formatearFecha = (fecha: string) => {
    if (!fecha) return '';
    const date = new Date(fecha);
    const dia = date.getDate().toString().padStart(2, '0');
    const mes = (date.getMonth() + 1).toString().padStart(2, '0'); // Los meses van de 0 a 11
    const anio = date.getFullYear();
    return `${dia}/${mes}/${anio}`;
  };
  
  

  
  
  const cargarEmpleados = async (idSupervisor: string) => {
    setCargando(true);
    try {
      const empleadosData = await CatEmpleados.GetIdSupervisor(idSupervisor);
      setEmpleados(empleadosData.data);
    } catch (error) {
      console.error('Error al cargar empleados:', error);
    } finally {
      setCargando(false);
    }
  };

  const cargarVacaciones = async (numEmpleado: string) => {
    try {
      const response = await CatVacaciones.GetAllVacacionesAndDetalle(numEmpleado);
      setVacaciones((prev) => ({
        ...prev,
        [numEmpleado]: response.data,
      }));
    } catch (error) {
      console.error('Error al cargar vacaciones:', error);
    }
  };

  const toggleRow = (numEmpleado: string) => {
    setExpandedRows((prev) => {
      const isExpanded = !prev[numEmpleado];
      if (isExpanded && !vacaciones[numEmpleado]) {
        cargarVacaciones(numEmpleado);
      }
      return {
        ...prev,
        [numEmpleado]: isExpanded,
      };
    });
  };

  const calcularEstadoPredominante = (numEmpleado: string) => {
    const vacacionesEmpleado = vacaciones[numEmpleado];
    if (!vacacionesEmpleado || vacacionesEmpleado.length === 0) {
      return 'Sin solicitudes'; // Sin solicitudes
    }

    if (vacacionesEmpleado.some((vacacion) => vacacion.estado === 'Pendiente')) {
      return 'Pendiente';
    }

    // if (vacacionesEmpleado.every((vacacion) => vacacion.estado === 'Aceptado')) {
    //   return 'Aceptado';
    // }

    return 'Sin solicitudes'; // Si todas son rechazadas o combinación de rechazadas y aceptadas
  };

  
 

  const getColorPorEstado = (estado: string) => {
    const colores = new Map<string, string>([
      ['Aceptado', '#d4edda'], // Verde claro
      ['Rechazado', '#f8d7da'], // Rojo claro
      ['Pendiente', '#ffcc99'], // Naranja claro en vez de amarillo
      ['Sin solicitudes', 'white'], // Blanco
      ['Anticipada', '#fff3cd'], 
    ]);
    return colores.get(estado) || 'white';
  };
  

  


  const handleEditClick = (vacacion: DTOVacaciones) => {
    setSelectedVacacion(vacacion);
    setEditModal(true);
  };




  






const handleSaveChanges = async () => {
  if (!isFotoFirmaValida) {
    setHeader('Advertencia');
    setMsg('No puedes aceptar o rechazar solicitudes porque no tienes una foto y firma registradas.');
    setShowMsg(true);
    return;
  }

  if (selectedVacacion) {
    try {
      if (selectedVacacion.estado === 'Rechazado') {
        const deleteData = {
          id: selectedVacacion.id,
          numEmpleado: selectedVacacion.numEmpleado,
          FechaRegistro: selectedVacacion.fechaSolicitud,
        };
        const deleteResponse = await CatVacaciones.DeleteVacaciones(deleteData);

        setHeader('Informativo');
        setMsg(deleteResponse.data.Message || 'Solicitud eliminada correctamente');
        setShowMsg(true);
      } else {
        const fechaAceptacion = selectedVacacion.estado === 'Aceptado'
          ? new Date().toLocaleString('sv-SE')
          : ''; // <= aquí mandamos '' en lugar de undefined o null

        await CatVacaciones.putVacacionesEstado(
          selectedVacacion.id,
          selectedVacacion.estado,
          selectedVacacion.comentario || '',
          fechaAceptacion
        );
      }

      // Enviar notificación
      await CatVacaciones.enviarNotificacionVacaciones(
        selectedVacacion.numEmpleado,
        selectedVacacion.nombre,
        selectedVacacion.correo,
        selectedVacacion.estado,
        selectedVacacion.comentario || ''
      );

      await cargarVacaciones(selectedVacacion.numEmpleado);
      setEditModal(false);
      setSelectedVacacion(null);
    } catch (error) {
      console.error('Error al guardar cambios:', error);
      alert('Ocurrió un error al intentar guardar los cambios.');
    }
  }
};


  const handleCancelEdit = () => {
    setEditModal(false);
    setSelectedVacacion(null);
  };

  const tienePendientes = empleados.some(
    (empleado) => calcularEstadoPredominante(empleado.numEmpleado) === 'Pendiente'
  );
  

  const getRowClass = (estado: string) => {
    return estado === "Pendiente" ? "fila-pendiente" : "";
  };
  

  const styles = `
  .encabezado-pendiente {
    background-color: #ffcc99 !important; /* Naranja */
    color: black !important;
    font-weight: bold !important;
  }

  .encabezado-normal {
    background-color: white !important; /* Fondo normal */
    color: black !important;
  }

  .fila-pendiente td {
    background-color: #ffcc99 !important; /* Naranja */
  }
    
`;





 const abrirSolicitudDesdeEmpleado = (empleado: DTOEmpleadoVac) => {
    setSolicitudData({
      numEmpleado: empleado.numEmpleado,
      tipoSolicitud: 'VacacionesPorDisfrutar',
      diasSolicitados: 0,
      diasPagar: 0,
      diasSalteados: [],
      fechaInicio: '',
      fechaFin: '',
      observaciones: '', 
      estado: 'Anticipada', 
      diaPago: null
    });
    setShowModalSolicitud(true);
  };






const handleGuardarSolicitud = async () => {
   const diasTomar = solicitudData.diasSalteados?.length || 0;
  const diasPagar = solicitudData.diasPagar || 0;

  if (diasTomar <= 0 && diasPagar <= 0) {
    setHeader('Error');
    setMsg('No puedes generar una solicitud con 0 días a tomar y 0 días a pagar.');
    setShowMsg(true);
    return;
  }

  if (diasPagar > 0 && !solicitudData.diaPago) {
    setHeader('Error');
    setMsg('Debes seleccionar el día de pago cuando ingresas días a pagar.');
    setShowMsg(true);
    return;
  }


  const payload: DTOInsertVacaciones = {
    ...solicitudData,
    diasSolicitados: solicitudData.diasSalteados.length
  };

  try {
    const response = await CatVacaciones.PostInsertVacaciones(payload);

    
    
    // const updated = await CatVacaciones.GetAllVacacionesAndDetalle(payload.numEmpleado);
    // const nuevaVacacion = updated.data?.[updated.data.length - 1]; // la última solicitud 
    
      const updated = await CatVacaciones.GetAllVacacionesAndDetalle(payload.numEmpleado);

      const nuevaVacacion = updated.data?.reduce(
        (max: DTOVacaciones | null, item: DTOVacaciones) =>
          !max || item.id > max.id ? item : max,
        null
      );

      
    /// CORREOOO 
    if (!nuevaVacacion || !nuevaVacacion.correo) {
      setHeader('Advertencia');
      setMsg('No se encontró el correo del empleado para enviar la notificación.');
      setShowMsg(true);
      return;
    }

    await CatVacaciones.enviarNotificacionVacaciones(
      nuevaVacacion.numEmpleado,
      nuevaVacacion.nombre,
      nuevaVacacion.correo,
      nuevaVacacion.estado,
      nuevaVacacion.observaciones || ''
    );

   

    setHeader('Éxito');
    setMsg(`Solicitud registrada correctamente y notificada a ${nuevaVacacion.correo}`);
    setShowMsg(true);
    setShowModalSolicitud(false);

    setSolicitudData({
      numEmpleado: '',
      tipoSolicitud: 'VacacionesPorDisfrutar',
      diasSolicitados: 0,
      diasPagar: 0,
      diasSalteados: [],
      fechaInicio: '',
      fechaFin: '',
      observaciones: '',
      estado: 'Anticipada',
      diaPago: null
    });

    await cargarVacaciones(payload.numEmpleado);

  } catch (error: any) {
    console.error('Error al guardar la solicitud:', error);
    setHeader('Error');
    setMsg(error?.response?.data?.message || 'Error al guardar la solicitud.');
    setShowMsg(true);
  }
};















const formatDateLocal = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};



 const handleDayClick = (day: Date) => {
    if (day.getDay() === 0) {
      setHeader('Error');
      setMsg('No puedes seleccionar domingos.');
      setShowMsg(true);
      return;
    }
    const dateStr = day.toISOString().split('T')[0];
    const exists = solicitudData.diasSalteados.includes(dateStr);
    setSolicitudData(prev => ({
      ...prev,
      diasSalteados: exists
        ? prev.diasSalteados.filter(d => d !== dateStr)
        : [...prev.diasSalteados, dateStr]
    }));
  };



const formatDateLocalFromString = (dateStr: string): string => {
  const [year, month, day] = dateStr.split('-');
  return `${day}/${month}/${year}`;
};









const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);


  // return (
  //   <div className="container">

return (
  <div className="container vacaciones-container-root" id="root-vacaciones">

      {/* <h3 className="text-center mb-4">Control de Vacaciones</h3> */}
      {cargando ? (
        <p className="text-center">Cargando...</p>
      ) : (
        <Table className="MDTable" hover striped bordered>
          <thead>
            <tr>
              <th></th>
              <th>Numero Empleado</th>
              <th>Nombre</th>
              <th>Departamento</th>
              <th>Supervisor</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {/* {empleados.map((empleado) => { */}
            {currentEmpleados.map((empleado) => {

              const estadoPredominante = calcularEstadoPredominante(empleado.numEmpleado);
              const rowClass = getRowClass(estadoPredominante);
              return (
                <React.Fragment key={empleado.numEmpleado}>
                  <tr  className={rowClass}   >
                    <td
                      onClick={() => toggleRow(empleado.numEmpleado)}
                      style={{ cursor: 'pointer' }}
                    >
                      <IconContext.Provider value={{ color: 'blue', size: '15px' }}>
                        {expandedRows[empleado.numEmpleado] ? (
                          <BsChevronDown />
                        ) : (
                          <BsChevronRight />
                        )}
                      </IconContext.Provider>
                    </td>
                    <td>{empleado.numEmpleado}</td>
                    <td>{empleado.nombreEmpleado}</td>
                    <td>{empleado.departamento}</td>
                    <td>{empleado.nombreSupervisor}</td>
                    <td>{estadoPredominante}</td>
                  </tr>
                  {expandedRows[empleado.numEmpleado] && (
                    <tr>
                      <td colSpan={6}>
                        <table className="childTable" style={{ width: '100%' }}>
                          <thead>
                            <tr>
                              <th>Tipo de Solicitud</th>
                              {/* <th>Fecha Inicio</th>
                              <th>Fecha Fin</th> */}
                              <th>Dias Selecionados</th>
                              <th>Días a Tomar</th>
                              <th>Días a Pagar</th>
                              <th>Día de pago</th>
                              <th>Pendientes Disfrutar</th>
                              <th>Pendientes Pago</th>
                              <th>FechaSolicitud</th>
                              <th>Estado</th>
                              <th>ComentarioSuper</th>
                              <th>ObservacionesEmpleado</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                         
                          


                          <tbody>
  {vacaciones[empleado.numEmpleado]?.map((vacacion) => (
    <tr
      key={vacacion.id}
      style={{
        backgroundColor: getColorPorEstado(vacacion.estado),
      }}
    >
      <td>{vacacion.tipoSolicitud}</td>
      {/* <td>{formatearFecha(vacacion.fechaInicio)}</td>
      <td>{formatearFecha(vacacion.fechaFin)}</td> */}
      <td>
  {Array.isArray(vacacion.diasSalteados)
    ? vacacion.diasSalteados.map((dia, index) => (
        <div key={index}>{formatearFechaISO(dia)}</div>
      ))
    : vacacion.diasSalteados
    ? vacacion.diasSalteados.split(',').map((dia, index) => (
        <div key={index}>{formatearFechaISO(dia)}</div>
      ))
    : 'N/A'}
</td>

      <td>{vacacion.diasTomar}</td>
      <td>{vacacion.diasPagar}</td>
       {/* <td>{vacacion.diaPago}</td> */}
       <td>{vacacion.diaPago ? formatearFecha(vacacion.diaPago) : 'N/A'}</td>
      <td> {vacacion.diasRestantes} </td>
      <td>{vacacion.diasPorPagar}</td>
      <td>{formatearFecha(vacacion.fechaSolicitud)}</td>
      {/* <td>{vacacion.fechaSolicitud}</td> */}
      <td>{vacacion.estado}</td>
      <td>{vacacion.comentario}</td>
      <td>{vacacion.observaciones}</td>
      <td>
        <IconContext.Provider value={{ color: 'blue', size: '15px' }}>
          <BsPencil
            style={{
              cursor: vacacion.estado === 'Aceptado' ? 'not-allowed' : 'pointer',
              color: vacacion.estado === 'Aceptado' ? 'gray' : 'blue',
            }}
            onClick={() => {
              if (vacacion.estado !== 'Aceptado') {
                handleEditClick(vacacion);
              }
            }}
          />
        </IconContext.Provider>
      </td>
      



    </tr>
  ))}
</tbody>

                        </table>

 <Button
  variant="success"
  size="sm"
  onClick={() => abrirSolicitudDesdeEmpleado(empleado)}
>
  Registrar solicitud anticipada
</Button>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </Table>



            

            



      )}

      {totalPages > 1 && (
  <div className="d-flex justify-content-center my-3">
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      className="mx-1"
    >
      Anterior
    </Button>
    <span className="align-self-center mx-2">
      Página {currentPage} de {totalPages}
    </span>
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      className="mx-1"
    >
      Siguiente
    </Button>
  </div>
)}


      {/* Modal para editar estado y comentario */}
      <Modal show={editModal} onHide={handleCancelEdit}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Estado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="estadoSelect">
              <Form.Label>Estado</Form.Label>
              <Form.Control
                as="select"
                value={selectedVacacion?.estado || ''}
                onChange={(e) =>
                  setSelectedVacacion((prev) =>
                    prev ? { ...prev, estado: e.target.value } : null
                  )
                }
              >
                <option value="Pendiente">Pendiente</option>
                <option value="Aceptado">Aceptado</option>
                <option value="Rechazado">Rechazado</option>
                <option value="Anticipada">Anticipada</option>

              </Form.Control>
            </Form.Group>
            <Form.Group controlId="comentarioInput">
              <Form.Label>Comentario</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={selectedVacacion?.comentario || ''}
                onChange={(e) =>
                  setSelectedVacacion((prev) =>
                    prev ? { ...prev, comentario: e.target.value } : null
                  )
                }
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelEdit}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleSaveChanges}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>



      <Modal show={showModalSolicitud} onHide={() => setShowModalSolicitud(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Registrar Solicitud Anticipada</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group>
        <Form.Label>Número de Empleado</Form.Label>
        <Form.Control type="text" value={solicitudData.numEmpleado || ''} readOnly />
      </Form.Group>

      {/* <Form.Group>
        <Form.Label>Nombre</Form.Label>
        <Form.Control type="text" value={solicitudData.nombre || ''} readOnly />
      </Form.Group> */}

      {/* <Form.Group>
        <Form.Label>Departamento</Form.Label>
        <Form.Control type="text" value={solicitudData.departamento || ''} readOnly />
      </Form.Group> */}


    <Form.Group>
  <Form.Label>Fechas a disfrutar</Form.Label>
  <Calendar
  onClickDay={handleDayClick}
  tileDisabled={({ date }) => date.getDay() === 0} // Bloquear domingos
  tileClassName={({ date }) =>
    solicitudData.diasSalteados?.includes(formatDateLocal(date))
      ? 'selected-day'
      : ''
  }
/>




  <Form.Text className="text-muted">
    Selecciona los días uno por uno. No se permiten domingos.
  </Form.Text>

 <ul>
  {solicitudData.diasSalteados?.map((d, i) => (
  <li key={i}>{formatDateLocalFromString(d)}</li>
))}

</ul>

</Form.Group>

<Form.Group>
  <Form.Label>Días a Tomar</Form.Label>
  <Form.Control
    type="text"
    readOnly
    value={solicitudData.diasSalteados?.length || 0}
    style={{
      backgroundColor: '#e9ecef',
      color: '#6c757d',
      cursor: 'not-allowed',
    }}
  />
</Form.Group>


<Form.Group className="mt-3">
              <Form.Label>Días a Pagar</Form.Label>
              <Form.Control type="number" min={0} value={solicitudData.diasPagar} onChange={(e) => setSolicitudData(prev => ({ ...prev, diasPagar: Number(e.target.value) }))} />
            </Form.Group>

<Form.Group className="mt-3">
  <Form.Label>Día de Pago (jueves)</Form.Label>

  <div style={{ position: 'relative' }}>
    <Form.Control
      type="text"
      readOnly
      value={
        solicitudData.diaPago
          ? new Date(solicitudData.diaPago + 'T12:00:00').toLocaleDateString('es-MX', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : ''
      }
      placeholder="Seleccionar jueves de pago"
      onClick={() => setShowDiaPagoCalendar((prev) => !prev)}
      style={{ cursor: 'pointer' }}
    />

    {showDiaPagoCalendar && (
      <div
        style={{
          position: 'absolute',
          zIndex: 9999,
          background: 'white',
          boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
          borderRadius: '8px',
          padding: '8px',
          marginTop: '5px',
        }}
      >
       <Calendar
  onClickDay={(date) => {
    if (date.getDay() === 4) {
      const localDate = formatDateLocal(date);

      setSolicitudData((prev) => ({
        ...prev,
        diaPago: prev.diaPago === localDate ? null : localDate,
      }));

      setShowDiaPagoCalendar(false);
    } else {
      setHeader('Advertencia');
      setMsg('Solo puedes seleccionar un jueves para el pago. Si no aplica, déjalo en blanco.');
      setShowMsg(true);
    }
  }}
  tileDisabled={({ date }) => {
    return date.getDay() !== 4;
  }}
  tileClassName={({ date }) => {
    const localDate = formatDateLocal(date);
    return solicitudData.diaPago === localDate ? 'selected-day' : '';
  }}
/>



      </div>
    )}
  </div>

  <Form.Text className="text-muted">
    Solo puedes seleccionar jueves. Si no se pagarán días, puedes dejarlo en blanco.
  </Form.Text>
</Form.Group>

      <Form.Group>
        <Form.Label>Observaciones</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={solicitudData.observaciones || ''}
          onChange={(e) =>
            setSolicitudData((prev) => ({ ...prev, observaciones: e.target.value }))
          }
        />
      </Form.Group>
    </Form>


  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowModalSolicitud(false)}>
      Cancelar
    </Button>
    <Button variant="primary" onClick={handleGuardarSolicitud}>
      Confirmar
    </Button>
  </Modal.Footer>
</Modal>

                  
                  {!isFotoFirmaValida && (
  <div className="alert alert-warning text-center" role="alert">
    No puedes aprobar/rechazar solicitudes porque no tienes una foto y firma registrada.
  </div>
)}
{/* <CalendarioPresolicitudes recargar={recargarCalendario} /> */}


<CalendarioSolicitudes/>








        <MsgInformativo
                               show={show}
                               msg={msg}
                               header={header}
                               msgColor={msgColor}
                               closeToast={() => {
                                 setShowMsg(false)
                               }}
                             /> 
                             
    </div>

                               

  );
};

export default ControlVacaciones;
